import Gender from "constants/type/user/Gender";

/** Minutes since midnight -> "HH:MM". Same arithmetic as bridge's intToTime. */
export const intToTime = (t) => {
  const hours = String(Math.floor(t / 60)).padStart(2, "0");
  const minutes = String(t % 60).padStart(2, "0");

  return `${hours}:${minutes}`;
};

/**
 * "10:00 - 10:30 AM" — the design shows the slot as a range with a single
 * meridiem, where bridge shows only the bare 24h start time. Duration comes from
 * the service; without it we can only render the start.
 */
export const formatTimeSlot = (timeSlot, durationMinutes) => {
  if (timeSlot === undefined || timeSlot === null) return "";

  const to12h = (mins) => {
    const h24 = Math.floor(mins / 60) % 24;
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
    return `${h12}:${String(mins % 60).padStart(2, "0")}`;
  };
  const meridiem = (mins) => (Math.floor(mins / 60) % 24 < 12 ? "AM" : "PM");

  if (!durationMinutes) return `${to12h(timeSlot)} ${meridiem(timeSlot)}`;

  const end = timeSlot + durationMinutes;
  // Only the end's meridiem is shown, so a slot spanning noon or midnight would
  // read misleadingly (e.g. "11:30 - 12:00 PM"); show both when they differ.
  return meridiem(timeSlot) === meridiem(end)
    ? `${to12h(timeSlot)} - ${to12h(end)} ${meridiem(end)}`
    : `${to12h(timeSlot)} ${meridiem(timeSlot)} - ${to12h(end)} ${meridiem(end)}`;
};

/**
 * "26 Aug 2025". Forced to UTC: appointmentDate is a UTC instant and rendering
 * it in the viewer's zone would shift the date across a day boundary.
 */
const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: "UTC",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

export const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";

  return dateFormatter.format(d);
};

/** "(M/24)" — omitted entirely when neither gender nor age is known. */
export const formatGenderAge = (gender, age) => {
  const g =
    gender === Gender.MALE ? "M" : gender === Gender.FEMALE ? "F" : "";
  if (!g && !age) return "";
  if (!g) return `(${age})`;
  if (!age) return `(${g})`;

  return `(${g}/${age})`;
};
